import {
    SET_COMPANY_CALLS_VIEW,
    SET_PAGINATION_END_BEFORE,
    SET_PAGINATION_START_AFTER,
    SET_PAGINATION_STEP,
    SET_SELECTED_EMPLOYEE
} from "./types";

const initState = {
    selectedEmp: {
        id: '',
        firstN: '',
        lastN: '',
    },
    companyCallsView: 'active',

    pagination: false,
    paginationSteps: 15,
    paginationStartAfter: null,

}

export const uxEnhanceReducer = (state = initState, action) => {
    switch (action.type) {
        case SET_SELECTED_EMPLOYEE:
            return {
                ...state,
                selectedEmp: {
                    id: action.payload.id,
                    firstN: action.payload.firstN,
                    lastN: action.payload.lastN,
                }
            }
        case SET_COMPANY_CALLS_VIEW:
            return {
                ...state,
                companyCallsView: action.payload.view,
            }

        case SET_PAGINATION_STEP:
            return {
                ...state,
                paginationSteps: action.payload.paginationSteps
            }
        case SET_PAGINATION_START_AFTER:
            return {
                ...state,
                paginationStartAfter: action.payload.paginationStartAfter
            }

        default:
            return state
    }
}